import { InboundRemittance } from "../../../types/reconciliation";
import { InfoCircleOutlined } from "@ant-design/icons";
import React, {useState} from "react";
import { Button, Form, Input, Modal, message } from "antd";
import { usePatchRemittanceMutation } from "../../../redux/api/reconciliationsApiSlice";

export const RemittanceNotesButton = ({ remittance }: { remittance: InboundRemittance }) => {

  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const [patchRemittance, { isLoading }] = usePatchRemittanceMutation();

  const [open, setOpen] = useState(false);

  return (
    <>
      {contextHolder}
      <Modal open={open} onCancel={() => setOpen(false)} title={"Nota"}
             okButtonProps={{ disabled: isLoading, loading: isLoading }} onOk={() => {
        form.validateFields().then((values) => {
          patchRemittance({
            remittance_uuid: remittance.uuid,
            name: values.name,
            notes: values.notes
          }).unwrap().then(() => {
            setOpen(false);
          }).catch((err) => {
            console.error("could not patch remittance due to an error: ", err);
            messageApi.error("Errore nella modifica della rimessa");
          });
        });
      }}>
        <Form form={form} layout={"vertical"} initialValues={{ name: remittance.name, notes: remittance.notes }}>
          <Form.Item name={"name"} label={"Nome rimessa:"}>
            <Input />
          </Form.Item>
          <Form.Item name={"notes"} label={"Note rimessa:"}>
            <Input.TextArea />
          </Form.Item>
        </Form>
      </Modal>
      <Button type={"text"} icon={<InfoCircleOutlined />} title={"Visualizza nota"} onClick={() => setOpen(true)} />
    </>

  );
};